export default class StringHelper {
  /**
   * Returns true if the passed string is a string and contains at least one char
   *
   *
   * Returns false otherwise
   */
  public static isNotEmpty = (string: string | undefined | null | unknown) => {
    if (
      string === null ||
      string === undefined ||
      typeof string !== "string" ||
      string.length <= 0
    )
      return false;

    return true;
  };

  public static isValidEmail = (email: string | undefined | null | unknown) => {
    if (!StringHelper.isNotEmpty(email)) return false;

    const email_ = email as string;

    return !!email_.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
  };

  public static parseInt(value: string): number {
    const parsed = Number.parseInt(value);
    if (Number.isNaN(parsed)) {
      return 0;
    }
    return parsed;
  }

  public static capitalizeFirstLetter(text: string) {
    return String(text).charAt(0).toUpperCase() + String(text).slice(1);
  }
}
